import { useState, useMemo } from "react";
import { startOfDay, addDays, startOfWeek } from "./constants";

export function useCalendarNav() {
  const [view, setView] = useState("week");
  const [anchor, setAnchor] = useState(() => new Date());

  const days = useMemo(() => {
    if (view === "day") return [startOfDay(anchor)];
    const s = startOfWeek(anchor);
    return Array.from({ length: 7 }, (_, i) => addDays(s, i));
  }, [view, anchor]);

  const navigate = (dir) => {
    if (view === "day") setAnchor((a) => addDays(a, dir));
    else if (view === "week") setAnchor((a) => addDays(a, dir * 7));
    else setAnchor((a) => new Date(a.getFullYear(), a.getMonth() + dir, 1));
  };

  return { view, setView, anchor, setAnchor, days, navigate };
}
